import { render, staticRenderFns } from "./BlogIndex.vue?vue&type=template&id=4ffba77a"
import script from "./BlogIndex.vue?vue&type=script&lang=ts"
export * from "./BlogIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports